<template>
  <div class="free-time-record">
    <div class="go-back" @click="goBack">>返回</div>

    <!--左侧上方搜索框-->

    <el-table
      ref="table"
      border
      :data="tableListData"
      height="100%"
      width="100%"
      :header-cell-style="tableHeaderStyle"
      :cell-style="styleObj"
    >
      <el-table-column
        show-overflow-tooltip
        label="车牌号码"
        prop="carNumber"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="关联订单号"
        prop="orderNum"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="停车时长"
        prop="parkingLongTime"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="预扣之前的剩余时长"
        prop="reductBefore"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="预扣之后的剩余时长"
        prop="reductAfter"
      ></el-table-column>
    </el-table>

    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { freeTimeRecord } from "@/api/url";

import Page from "../../commons/page";
export default {
  name:'free-time-record',
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      formLabelWidth: "100px",

      search: {
        pageSize: 10,
        pageNumber: 1,
        invoiceNatrue: "",
        orderNum: "",
        plateNumber: "",
      },

      tableListData: [],

      freeTimeRecord: {},
      pageObj:{}
    };
  },
  components: {
    Page,
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  created() {
    this.freeTimeRecord = JSON.parse(this.$route.query?.record ?? "{}");
  },
  mounted() {
    this.tableList(1);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      const { plaId } = this.freeTimeRecord;
      this.$get(freeTimeRecord(), {
        page: curPage,
        limit: this.search.pageSize,
        plaId,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.free-time-record {
  height: 100%;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.electronicIinvoice {
  display: inline-block;
  width: 60px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
}
.forbid {
  color: #ddd !important;
}
.go-back {
  padding: 20px 10px;
  cursor: pointer;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>
